(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mk-loop-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mk-loop-video')) {
    class MkLoopVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        const v = this.video;
        v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.current = null;
        this.near = false;
        this.visible = false;
        this.onChange = () => this.update();
        this.mqMobile.addEventListener('change', this.onChange);
        this.mqReduce.addEventListener('change', this.onChange);
        v.addEventListener('error', () => this.useFallback(), true);
        // Start playback as soon as data is ready if the video is on screen.
        v.addEventListener('canplay', () => { if (this.visible) this.play(); });
        // Fade the video in over the poster only once frames are actually playing.
        v.addEventListener('playing', () => this.classList.add('is-playing'));
        // Some browsers (e.g. iOS Low Power Mode) reject muted autoplay; retry on the first user gesture or scroll.
        this.onGesture = () => { if (this.visible) this.play(); };
        ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((t) => window.addEventListener(t, this.onGesture, { passive: true }));
        // Resume after returning to the tab.
        this.onVis = () => { if (document.visibilityState === 'visible') this.update(); };
        document.addEventListener('visibilitychange', this.onVis);
        if ('IntersectionObserver' in window) {
          // Load the source a little before the video scrolls in.
          this.ioNear = new IntersectionObserver((entries) => {
            this.near = entries.some((e) => e.isIntersecting);
            this.update();
          }, { rootMargin: '200px 0px' });
          this.ioNear.observe(this);
          // Play while at least 20% is on screen; pause when it leaves.
          this.ioView = new IntersectionObserver((entries) => {
            const e = entries[entries.length - 1];
            this.visible = e.isIntersecting && e.intersectionRatio >= 0.2;
            this.update();
          }, { threshold: [0, 0.2, 0.5] });
          this.ioView.observe(this);
        } else {
          this.near = true;
          this.visible = true;
        }
        this.update();
      }
      disconnectedCallback() {
        if (this.ioNear) this.ioNear.disconnect();
        if (this.ioView) this.ioView.disconnect();
        if (this.mqMobile) this.mqMobile.removeEventListener('change', this.onChange);
        if (this.mqReduce) this.mqReduce.removeEventListener('change', this.onChange);
        if (this.onGesture) ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((t) => window.removeEventListener(t, this.onGesture));
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
      }
      key() { return this.mqMobile.matches ? 'mobile' : 'desktop'; }
      update() {
        const k = this.key();
        // Respect the visitor's operating-system "reduce motion" setting: poster only.
        if (this.mqReduce.matches) {
          this.video.pause();
          this.video.removeAttribute('autoplay');
          return;
        }
        if (!this.near && !this.visible) {
          if (!this.video.paused) this.video.pause();
          return;
        }
        if (this.current !== k) {
          this.current = k;
          this.triedFallback = false;
          const src = this.dataset['src' + (k === 'mobile' ? 'Mobile' : 'Desktop')];
          if (!src) return;
          this.classList.remove('is-playing');
          this.video.src = src;
          this.video.load();
        }
        if (this.visible && document.visibilityState !== 'hidden') this.play();
        else if (!this.video.paused) this.video.pause();
      }
      useFallback() {
        if (this.triedFallback) return;
        this.triedFallback = true;
        const fb = this.dataset['fallback' + (this.key() === 'mobile' ? 'Mobile' : 'Desktop')];
        if (fb && fb !== this.video.currentSrc) {
          this.video.src = fb;
          this.video.load();
          if (this.visible) this.play();
        }
      }
      play() {
        const v = this.video;
        if (!v.paused) return;
        v.muted = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }
    }
    customElements.define('mk-loop-video', MkLoopVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
